// eslint-disable-next-line
const EMAIL_REG = /^[a-zA-Z0-9.!#$%&'*+\/=?^_`{|}~-]+@[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(?:\.[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)*$/;

export const isPhone = (phone: string) => /^1(3\d|4[5-9]|5[0-35-9]|6[567]|7[0-8]|8\d|9[0-35-9])\d{8}$/.test(phone);


export const isIOTPhone = (phone: string) => {
  const iotPhoneRegExps = [
    /^1476[4-6]\d{6}$/,
    /^148\d{8}$/,
    /^172[1-5]\d{7}$/,
    /^1729\d{8}$/,
    /^1789[2-4]\d{6}$/,
    /^1849\d{8}$/,
    /^1455[0-6][0-9][0-9]\d{4}$/,
    /^1457(4[7-9][0-9]|[5-6][0-9][0-9])\d{4}$/,
    /^14578[7-9][0-9]\d{4}$/,
    /^146\d{8}$/,
    /^1400\d{9}$/,
    /^10646\d{8}$/,
    /^149\d{8}$/,
    /^10649\d{6}$/,
  ];
  // 判断是否为物联网号码

  if (iotPhoneRegExps.some(regExp => regExp.test(phone))) {
    return true;
  }
  return false;
};

export const isEmail = (mail: string) => EMAIL_REG.test(mail);
